import { useEffect } from "react";

const PaymentSuccessRedirect = () => {
  useEffect(() => {
    window.parent.location = "/offers" + window.location.search;
  }, []);

  return null;
};

export default PaymentSuccessRedirect;
